import { setGlobalLoader } from '../context/LoaderContext';
import axios from 'axios';
import { Alert } from '../util/Alert';
import { deleteCookie, getCookie } from '../util/Cookie';

const isLocal = window.location.hostname.indexOf("localhost") >= 0 ? true : false;

export const url = isLocal ? 'https://localhost:7230' : process.env.REACT_APP_API_URL ?? 'https://bmgdetodos.com.br/api';

export default class Api {
    constructor(urlBase = "") {
        this.loginPage = "/login";
        this.api = axios.create({
            baseURL: urlBase,
            headers: {
                "Authorization": `Bearer ${getCookie("access_token")}`
            }
        });

        this.api.interceptors.request.use((config) => {
            const tokenFromCookie = getCookie("access_token");
            if (tokenFromCookie) {
                config.headers = config.headers || {};
                config.headers["Authorization"] = `Bearer ${tokenFromCookie}`;
            }
            return config;
        });
    }

    execute = (apiCall, funcResult, funcErr = null) => {
        setGlobalLoader(true);
        apiCall
            .then((response) => {
                funcResult?.(response);
                return;
                // Alert(response.data.message ?? "Erro desconhecido", "", false);
            })
            .catch((err) => {
                console.error(err);
                if (err.response?.status === 401 && err.response?.data?.message !== "Login ou senha inválidos") {
                    deleteCookie("access_token");
                    deleteCookie("user_data");
                    window.location.href = this.loginPage;
                    return;
                }
                if (err.response?.status === 428) {
                    Alert(err.response.data.mensagem, "", false, false, true);
                    funcErr && funcErr(true, err.response.data.numeroSolicitacao, err.response.data.token);
                    return;
                }

                if (funcErr) {
                    funcErr(err.response.data);
                } else {
                    Alert(err.response?.data.mensagem ?? "Erro desconhecido", "", false);
                }
            })
            .finally(() => {
                setGlobalLoader(false);
            });
    };

    get = (url, funcResult, funcErr) => {
        this.execute(this.api.get(url), funcResult, funcErr);
    };

    delete = (url, funcResult, funcErr) => {
        this.execute(this.api.delete(url), funcResult, funcErr);
    };

    post = (url, form, funcResult, funcErr) => {
        this.execute(this.api.post(url, form), funcResult, funcErr);
    };

    put = (url, form, funcResult, funcErr) => {
        this.execute(this.api.put(url, form), funcResult, funcErr);
    };
}

export const api = new Api(url);
